import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const layoutDataQuery = gql`
  query LayoutData($organisationId: ID, $schemeType: ID!, $locale: String) {
    layoutData(organisationId: $organisationId, schemeType: $schemeType, locale: $locale) {
      employeeOrganisation {
        partner {
          source
          platformType
          dynamicBenefitJourney
          lockUserToDestinationBenefit
          signOutLabel
        }
        footerLinks {
          showAccessibility
          showContactUs
          showCookiePolicy
          showManageCookies
          showOrganisationPrivacyNotice
          showPrivacyPolicy
          showPromotionalTermsAndConditions
          showTermsAndConditions
          showVivupPrivacyNotice
          customFooterLinks {
            url
            label
            id
          }
        }
        id
        name
        organisationPayrollFrequencies {
          id
          name
        }
        customPrivacyNoticeUrl
        organisationPrivacyNotice
        logo
        condensedLogo
        footerLogo
        isValidBenefitType
        grossPriceOnProductCardFeatureFlag
        availableLanguages {
          name
          locale
          code
        }
        defaultLanguage {
          locale
        }
        scheme {
          id
          windowStartDate
          windowEndDate
          store {
            departments {
              name
              link
            }
          }
          supplierDesktopBanner
          supplierMobileBanner
          startDate
          endDate
          quoteType
          weeksPerYear
          supportLinks {
            label
            url
            content
          }
          banners {
            desktopImageUrl
            mobileImageUrl
            link
            title
            subtitle
          }
          basket {
            id
            count
            monthlyPrice
            term
            totalMonthlyGrossAmount
            disposalFee
            endOfAgreementFee
            totalSavings
            totalRrp
          }
        }
      }
      currentUser {
        id
        backendUser
        employeeOrganisations {
          name
          changePortalLink
        }
        payrollFrequency
      }
    }
  }
`

export const getLayoutDataQueryKey = getQueryNames(layoutDataQuery)[0]
export {layoutDataQuery}
